import { render } from "./HomeItsAboutUsComp.vue?vue&type=template&id=940c27fa&scoped=true"
import script from "./HomeItsAboutUsComp.vue?vue&type=script&lang=js"
export * from "./HomeItsAboutUsComp.vue?vue&type=script&lang=js"

import "./HomeItsAboutUsComp.vue?vue&type=style&index=0&id=940c27fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940c27fa"]])

export default __exports__